import React, { forwardRef } from 'react'
import { Button } from 'components/UIElements'
import SurveyQuestion from '../SurveyQuestion'
import {
  checkLogicAndComplete,
  buildOrderedReviewQuestions,
  getShouldRenderNextQuestion,
  isQuestionIncludedInReview
} from '../../utils/instrumentUtils'
import ReviewQuestionItem from '../ReviewQuestionItem'
import { getInstrumentFromLocalStorage } from '../../../Activities/utils/instrumentUtils'

const Review = forwardRef((props, ref) => {
  const {
    scrollToPreviousQuestion,
    webSurvey,
    id,
    submissionSurvey,
    currentAnswer,
    nextQId,
    nextQ,
    completeQuestion,
    submission,
    strings,
    reviewFunctionalitySupported,
    participantId,
    isConsent = false,
    isLastQuestion = false,
    isSibling = false
  } = props

  const webSurveyQuestions = webSurvey?.questions
  // GOLD-12260: Same inclusion rules as navigation so TMG stays off
  // Review unless in_review is explicitly true. Mixed instruments still
  // list the other question types.
  const inReviewIdMap = Object.keys(webSurveyQuestions || {}).reduce((acc, key) => {
    return {
      ...acc,
      [key]: isQuestionIncludedInReview(webSurveyQuestions[key])
    }
  }, {})

  const instrumentId =
    submissionSurvey?.identity ||
    submissionSurvey?.instrument_id ||
    webSurvey?.id
  const storedInstrument =
    participantId && instrumentId
      ? getInstrumentFromLocalStorage({ participantId, instrumentId })
      : null

  const filteredQuestions = buildOrderedReviewQuestions({
    webSurvey,
    submissionSurvey,
    storedInstrument,
    inReviewIdMap
  })

  const onEditQuestion = id => {
    scrollToPreviousQuestion(id, '0')
  }

  return (
    <SurveyQuestion id={id}>
      <div className='review-content' ref={ref}>
        <div className='review-content-inner'>
          <div className='review-content-title'>
            {strings.survey_answer_review_title ||
              'Review your entry before submission'}
          </div>
          <div className='review-content-list'>
            {filteredQuestions.map((question, index) => (
              <ReviewQuestionItem
                key={`${question.id ?? 'q'}-${index}`}
                question={question}
                onEditQuestion={onEditQuestion}
                strings={strings}
              />
            ))}
          </div>
          <div className='review-content-buttons'>
            <Button
              className='secondary-button'
              content={strings.back || 'Back'}
              onClick={() => {
                const lastId =
                  filteredQuestions[filteredQuestions.length - 1]?.id
                if (lastId) scrollToPreviousQuestion(lastId, '0')
              }}
              icon='fa fa-chevron-up'
            />
            <Button
              className='primary-button'
              content={
                strings.consent_read_confirm_button || 'Confirm'
              }
              onClick={() => {
                nextQId('review')
                nextQ('review')
                const shouldRenderNextQ = getShouldRenderNextQuestion({
                  isConsent,
                  isLastQuestion,
                  isSibling
                })
                checkLogicAndComplete(
                  webSurvey,
                  'review',
                  submissionSurvey,
                  currentAnswer,
                  nextQId,
                  nextQ,
                  completeQuestion,
                  submission,
                  reviewFunctionalitySupported,
                  shouldRenderNextQ
                )
              }}
            />
          </div>
        </div>
      </div>
    </SurveyQuestion>
  )
})

export default Review
